import React from "react";
import { Link } from "react-router-dom";

const Logo = () => {
  return (
    <Link to="/" className="shrink-0" aria-label="ContainX home">
      <div className="flex h-20 items-center text-2xl sm:text-3xl">
        <img
          src={`${process.env.PUBLIC_URL}/containx-logo-192.png`}
          alt=""
          className="mr-2 h-12 w-12"
        />
        <span className="font-bold text-logo ">ContainX</span>
      </div>
    </Link>
  );
};

export default Logo;
